
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["unf-icon",classNames,staticClass],
              style: [{"vertical-align":"middle"},style,staticStyle],
              attrs: Object.assign({"class":"unf-icon","width":"24","height":"24","fill":"var(--NN500, #8D96AA)","style":"vertical-align:middle","display":"inline-block"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M21.71 9.29a2.28 2.28 0 00-2.33-2 1.13 1.13 0 00-.55.15 7.73 7.73 0 00-13.7 0 1.16 1.16 0 00-.55-.15 2.27 2.27 0 00-2.35 2.13v2.15a2.26 2.26 0 002.35 2.17h.15a7.75 7.75 0 0014.5 0h.15c.318 0 .633-.057.93-.17A8.75 8.75 0 0117 18.42a7.842 7.842 0 01-1.82 1.09.762.762 0 10.32 1.49.66.66 0 00.3-.07A8.62 8.62 0 0018 19.6c2.89-2.17 4.3-5.31 4.3-9.61a.74.74 0 00-.59-.7zM4.23 12.18a.7.7 0 01-.5-.61V9.42a.71.71 0 01.5-.61v3.37zM12 17.24a6.25 6.25 0 11-.04-12.5 6.25 6.25 0 01.04 12.5zm8.25-5.67a.7.7 0 01-.5.61V8.81a.71.71 0 01.5.61v2.15zM15 11.24a.75.75 0 00-.75.75 2.25 2.25 0 01-4.5 0 .75.75 0 10-1.5 0 3.75 3.75 0 107.5 0 .76.76 0 00-.75-.75zm-4.53 8.72a.75.75 0 01.53-.22h2a.75.75 0 110 1.5h-2a.75.75 0 01-.53-1.28z"}})])
          )
        }
      }
    